import type { TvChannel } from '@setplex/tria-api'

import { aye } from '~/shared/helpers'

interface IsChannelLockedAndPrevChannelNotPurchasedAndLockedParamsI {
  channel: TvChannel | null
  prevChannel: TvChannel | null
}
export function isChannelLockedAndPrevChannelNotPurchasedAndLocked({
  channel,
  prevChannel,
}: IsChannelLockedAndPrevChannelNotPurchasedAndLockedParamsI) {
  return aye(
    channel != null &&
      prevChannel != null &&
      channel.locked &&
      !channel.purchaseInfo &&
      prevChannel.locked
  )
}
